var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "formatter" }, [
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("TimezonePickerInput", {
          attrs: { title: "From Timezone" },
          model: {
            value: _vm.clone.isYesterday.fromTimezone,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isYesterday, "fromTimezone", $$v)
            },
            expression: "clone.isYesterday.fromTimezone",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("FormatPickerInput", {
          attrs: { title: "From Format" },
          model: {
            value: _vm.clone.isYesterday.fromFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isYesterday, "fromFormat", $$v)
            },
            expression: "clone.isYesterday.fromFormat",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("LocalePickerInput", {
          attrs: { title: "From Locale" },
          model: {
            value: _vm.clone.isYesterday.fromLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isYesterday, "fromLocale", $$v)
            },
            expression: "clone.isYesterday.fromLocale",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }